import React from 'react';
import PropTypes from 'prop-types';
import { ResourceRequestStatus } from '~/types';
import ResourceRequestChartBanner from '~/modules/resourcing/common/components/ResourceRequestChartBanner/ResourceRequestChartBanner';
import { hasAcceptActionAllowed } from '~/modules/resourcing/common/components/ResourceMatchItem/permissionUtil';
import { ResourceRequestAcceptAllButton } from './ResourceRequestAcceptAllButton';

export const ResourceRequestAcceptAllChartBanner = ({
  resourceRequests,
  allocationChartRef,
  project
}) => {
  const hasPermission = hasAcceptActionAllowed(project);
  const submittedResourceRequests = hasPermission
    ? resourceRequests.filter(
        resourceRequest =>
          resourceRequest.requestStatus === ResourceRequestStatus.Submitted &&
          resourceRequest.resourceMatches?.length
      )
    : [];

  return submittedResourceRequests.length ? (
    <ResourceRequestChartBanner messageId="resourceRequestChartBanner.acceptRequests">
      <ResourceRequestAcceptAllButton
        resourceRequests={submittedResourceRequests}
        allocationChartRef={allocationChartRef}
      />
    </ResourceRequestChartBanner>
  ) : null;
};

ResourceRequestAcceptAllChartBanner.propTypes = {
  resourceRequests: PropTypes.array.isRequired,
  allocationChartRef: PropTypes.object,
  project: PropTypes.object
};
export default ResourceRequestAcceptAllChartBanner;
